import { z } from 'zod';
/**
 * Canonical API error codes. Single source of truth for backend responses,
 * frontend handling and E2E assertions. Keep alphabetical within groups.
 */
export const API_ERROR_CODES = {
    // Generic
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    RATE_LIMITED: 'RATE_LIMITED',
    // Trials / study roles
    TRIAL_ROLE_DUPLICATE: 'TRIAL_ROLE_DUPLICATE',
    TRIAL_ROLE_IN_USE: 'TRIAL_ROLE_IN_USE',
    // Trial visit groups (D2, #40)
    TRIAL_VISIT_GROUP_DUPLICATE: 'TRIAL_VISIT_GROUP_DUPLICATE',
    TRIAL_VISIT_GROUP_IN_USE: 'TRIAL_VISIT_GROUP_IN_USE',
    // Trial visit catalog (#44 A1 / #40 W4) — Nazwa1+Nazwa2 duplicate within a
    // trial, compared trim + case-insensitive (409)
    TRIAL_VISIT_DUPLICATE: 'TRIAL_VISIT_DUPLICATE',
    // Template visits (D3, #41) — preset added twice to one enrollment (409)
    TEMPLATE_VISIT_DUPLICATE: 'TEMPLATE_VISIT_DUPLICATE',
    // Visit personnel registration (D4, #32) — REQ-VIS-027: only ACTIVE
    // site-staff assignments of the visit's OWN trial may be registered (409)
    VISIT_PERSONNEL_INACTIVE: 'VISIT_PERSONNEL_INACTIVE',
    VISIT_PERSONNEL_EXTERNAL_ROLE: 'VISIT_PERSONNEL_EXTERNAL_ROLE',
    VISIT_PERSONNEL_CROSS_TRIAL: 'VISIT_PERSONNEL_CROSS_TRIAL',
    // Cockpit trial bars (D4, #7) — bars are per-USER; membership is a set
    // (a trial appears at most once on one bar) and only ACTIVE trials may be
    // added (REQ-TRIAL-002); capacity is the bar's configured bound (409)
    TRIAL_BAR_FULL: 'TRIAL_BAR_FULL',
    TRIAL_BAR_ITEM_DUPLICATE: 'TRIAL_BAR_ITEM_DUPLICATE',
    TRIAL_BAR_TRIAL_INACTIVE: 'TRIAL_BAR_TRIAL_INACTIVE',
    // Auth / tenancy
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    FORBIDDEN: 'FORBIDDEN',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    INVALID_MFA_CODE: 'INVALID_MFA_CODE',
    MFA_REQUIRED: 'MFA_REQUIRED',
    PASSWORD_TOO_WEAK: 'PASSWORD_TOO_WEAK',
    TENANT_MISMATCH: 'TENANT_MISMATCH',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    // Documents / PDF rendering (ADR-010, issue #10 atom 5)
    PDF_RENDER_FAILED: 'PDF_RENDER_FAILED',
    PDF_RENDER_TIMEOUT: 'PDF_RENDER_TIMEOUT',
};
export const ApiErrorCodeSchema = z.enum(Object.values(API_ERROR_CODES));
/** Standard error envelope returned by every failing endpoint. */
export const ApiErrorSchema = z.object({
    code: ApiErrorCodeSchema,
    message: z.string().min(1),
    details: z.unknown().optional(),
});
//# sourceMappingURL=errors.js.map